import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FillRestWithLine from 'pages/june-5/components/text-and-line'
import {Spacer} from 'layout/util'

const SectionTitle = styled.h2`
	display: inline;
	margin: 20px 0 3px 0;
	@media screen and (max-width: 767px) {
		text-align: center;
		display: inline-block;
	}
`;
const SectionSubtitle = styled.div`
	font-style: italic;
	font-size: 14px;
	text-align: ${props=>props.align};
	@media screen and (max-width: 767px) {
		text-align: center;
	}
`;

const Img = styled.img`
	display: inline;
	width: 32px;
	margin-right: ${props=>props.isReversed?0:10}px;
	margin-left: ${props=>props.isReversed?10:0}px;
	transform: rotate(${props=>props.isReversed?-13:13}deg);
	@media screen and (max-width: 767px) {
		display: block;
		margin: 0 auto; 
	}
	
`;

const TitleBar = (props) => {
	const {img, title, subtitle, align} = props;
	const isReversed = (align==="right");
	return(
		<div>
    	<Spacer height={30}/>
    	<FillRestWithLine align={align}>
				{img && !isReversed && <Img src={img} isReversed={isReversed} alt="title image"/>}
				<SectionTitle>{title}</SectionTitle>
				{img && isReversed && <Img src={img} isReversed={isReversed} alt="title image"/>}
    	</FillRestWithLine>
			{subtitle && 
				<SectionSubtitle align={align}>
					{subtitle}
				</SectionSubtitle>
			}
		</div>
	)
}

TitleBar.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	img: PropTypes.string,
	align: PropTypes.string,
}

export default TitleBar;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/SectionTitle.js